import { createStyles } from '@byecode/ui/theme/createStyles'
import { css } from '@byecode/ui/theme/stitches.config'

export const useStyles = createStyles(() => ({
    tooltip: css({
        borderRadius: 4,
        color: '$colorWhite',
        backgroundColor: '$colorGray900',
        padding: '6px 8px',
        fontSize: 12,
        lineHeight: 1.5,
        textAlign: 'justify'
    })
}))
